<div class="update-contact-dialog">
  <div class="update-contact-dialog-header flex-between-center">
    <p class="m-0 font-bold">
      <i class="far fa-address-book pr-2 font-gray-45 font-20"></i>
      <span class="font-16 font-bold">Update Contacts </span>
    </p>

    <span class="close-modal"><i class="fal fa-times" (click)="handleClose()"></i></span>
  </div>

  <div class="update-contact-dialog-body">
    <div *ngIf="prefrenceType" class="row mx-0 p-0 mt-2 mb-3">
      <div class="d-flex prefrence">
        <p class="padding-zero font-14 mb-0 font-600" id="update-communication-preference">Communication preference</p>
        <div class="pl-2">
          <span class="pr-2">
            <app-checkbox inputId="cb-customer-update-email" label="Email" [isChecked]="prefrenceType.contactOnEmail"
              [disabled]="!emails?.length || isMFCustomer" (appChange)="handleChange('contactOnEmail', $event)"
              id="update-communication-preference-email"></app-checkbox>
          </span>
          <span>
            <app-checkbox inputId="cb-customer-update-phone" label="Mobile" [isChecked]="prefrenceType.contactOnPhone"
              [disabled]="!phones?.length || isMFCustomer" id="update-communication-preference-mobile"
              (appChange)="handleChange('contactOnPhone', $event)"></app-checkbox>
          </span>
        </div>
      </div>
    </div>

    <div class="row mx-0 p-0 mt-2 border-bottom-light pb-2">
      <div class="col p-0 rec-type">
        <p class="m-0 font-bold font-secondary-700">Type</p>
      </div>

      <div class="col p-0 rec-phone">
        <p class="m-0 font-bold font-secondary-700 pl-6p">Phone</p>
      </div>

      <div *ngIf="isMFCustomer" class="col rec-label">
        <img src="assets/myFleetCenterIntegration-icon.svg" />
        <span class="m-0 font-bold font-secondary-700 pl-6p">MFC Label</span>
      </div>

      <div class="col rec-label">
        <p class="m-0 font-bold font-secondary-700 pl-6p">Label</p>
      </div>

      <div class="col rec-primary text-center">
        <p class="m-0 font-bold font-secondary-700 text-center">Primary</p>
      </div>

      <div class="col rec-active text-center">
        <p class="m-0 font-bold font-secondary-700">Active</p>
      </div>

      <ng-container *ngIf="isMarketingOptOutEnabled && contactEntityType === 'customer'">
        <div *ngIf="isMarketingEnabled" class="col p-0 rec-marketing">
          <p class="m-0 font-bold font-secondary-700 pl-6p text-center">
            <span class="pr-2">Marketing</span>
            <i class="fal fa-info-circle text-dark" tooltipPosition="top" tooltipStyleClass="tooltip-z-index"
              pTooltip="Opt out/in of receiving promotional campaigns & follow-up reminders"></i>
          </p>
        </div>

        <div class="col-2 p-0 rec-reminders">
          <p class="m-0 font-bold font-secondary-700 pl-6p text-center">
            <span class="pr-2">Operational reminders</span>
            <i class="fal fa-info-circle text-dark" tooltipPosition="top" tooltipStyleClass="tooltip-z-index"
              pTooltip="Opt out/in of receiving appointment, payment review requests & send estimate reminders"></i>
          </p>
        </div>
      </ng-container>

      <div class="col p-0 rec-delete">
        <p class="m-0 font-bold font-secondary-700 pl-6p text-center">
          <!-- Delete -->
        </p>
      </div>
    </div>

    <div class="contact-body" #scrollPhone [scrollTop]="scrollPhone.scrollHeight"
      [ngClass]="{ 'dropdownActive': dropdownActive }">
      <div class="row mx-0 contact-row position-relative" [ngClass]="{ 'disabled-row': !phone?.isActive }"
        *ngFor="let phone of phones | slice:0:phoneLength; let phoneIndex = index">
        <div class="col p-0 rec-type">
          <!-- Phone type -->
          <app-dropdown id="phone-type-{{ phoneIndex }}" listId="phone-list-type-{{ phoneIndex }}" placeholder="Type"
            theme="light" field="label" [disabled]="!phone?.isActive || isMFCustomer"
            [hasError]="errors.phones[phoneIndex]?.contactType" [value]="phone?.contactType" [errorMessage]=""
            [fontSize]="14" [listItemFontSize]="13" [floatingLabel]="false" [options]="phoneTypes"
            [isDropdownIconVisible]="true" (appOpenDropdown)="handleFocus(true)" (appCloseDropdown)="handleFocus(false)"
            (appSelect)="handleMultiChange('phones', 'contactType', phoneIndex, $event)"
            (appClickOutside)="handleFocus(false)">
          </app-dropdown>
        </div>

        <!-- Value -->
        <div class="col p-0 rec-phone">
          <app-input id="phone-{{ phoneIndex }}" validationId="error-phone-{{ phoneIndex }}" theme="light"
            placeholder="Phone" mask="(000) 000-0000" [disabled]="!phone?.isActive || isMFCustomer"
            [value]="phone.value" [isInvalid]="errors.phones[phoneIndex]?.value" [errorMessage]=""
            [floatingLabel]="false" (appChange)="handleMultiChange('phones', 'value', phoneIndex, $event)"
            (appBlur)="handleBlur('phone')"></app-input>
        </div>

        <div class="col rec-label flex-start-center" *ngIf="isMFCustomer">
          <div class="my-fleet-type-badge badge-blue" *ngIf="!phone?.isPrimary; else authBadge">
            {{phoneIndex === 1 ?'Contact':'Shipping'}}
          </div>
          <ng-template #authBadge>
            <div class="my-fleet-type-badge badge-green">
              Authorizer
            </div>
          </ng-template>
        </div>

        <!-- Label -->
        <div class="col rec-label input-elipsis">
          <app-input id="phone-label-{{ phoneIndex }}" validationId="error-phone-label-{{ phoneIndex }}" theme="light"
            placeholder="Label" [disabled]="!phone?.isActive || isMFCustomer" [value]="phone.label"
            [floatingLabel]="false" [isInvalid]="errors.phones[phoneIndex]?.label" [errorMessage]=""
            (appChange)="handleMultiChange('phones', 'label', phoneIndex, $event)" (appBlur)="handleBlur('label')">
          </app-input>
        </div>

        <!-- Primary -->
        <div class="col p-0 flex-center-center height-34 rec-primary">
          <div class="pt-8p">
            <app-radio-button id="email-primary-{{ phoneIndex }}" name="phone-primary" label=""
              styleClassLabel="font-seconday" [selectedValue]="phone?.isPrimary"
              [disabled]="!phone?.isActive || !phone?.value || phone?.contactType?.value === 'landline'" [value]="true"
              (appChange)="handleMultiChange('phones', 'isPrimary', phoneIndex, $event)">
            </app-radio-button>
          </div>
        </div>

        <!-- Active -->
        <div class="col p-0 flex-center-center height-34 rec-active">
          <div class="app-switch-right">
            <app-switch-pill id="email-active-{{ phoneIndex }}" position="end" [fontSize]="14"
              [isActive]="phone.isActive" [disabled]="phone?.isPrimary || isMFCustomer" [label]=""
              (appChange)="handleMultiChange('phones', 'isActive', phoneIndex, $event)">
            </app-switch-pill>
          </div>
        </div>

        <!-- Marketing -->
        <div *ngIf="isMarketingEnabled && isMarketingOptOutEnabled && !isSupplier"
          class="col p-0 flex-center-center height-34 rec-marketing">
          <app-switch-pill id="email-active-{{ phoneIndex }}" class="flex-center-center" position="end" [fontSize]="14"
            [isActive]="phone.isMarketingNotifEnabled"
            [disabled]="!phone.isActive"
            (appChange)="handleMultiChange('phones', 'isMarketingNotifEnabled', phoneIndex, $event)">
          </app-switch-pill>
        </div>

        <!-- Operational -->
        <div *ngIf="isMarketingOptOutEnabled && !isSupplier"
          class="col-2 p-0 flex-center-center height-34 rec-reminders">
          <app-switch-pill id="email-active-{{ phoneIndex }}" position="end" class="flex-center-center" [fontSize]="14"
            [isActive]="phone.isOperationalNotifEnabled"
            [disabled]="!phone.isActive"
            (appChange)="handleMultiChange('phones', 'isOperationalNotifEnabled', phoneIndex, $event)">
          </app-switch-pill>
        </div>

        <!-- Delete -->
        <div class="col p-0 rec-delete">
          <i class="fal fa-trash delete-btn font-gray-45 p-2" *ngIf="!phone?.isPrimary && !isMFCustomer"
            pTooltip="Delete" tooltipStyleClass="tooltip-z-index" tooltipPosition="top"
            (click)="handleDeleteContact('phones', phoneIndex)"></i>
        </div>
      </div>
    </div>


    <div class="p-0 mt-1 pointer" (click)="seeMore('phone')"
      *ngIf="phoneLength<=5 && !showHidePhone && isFleetCustomer">
      <i class="far fa-angle-down font-primary pr-1"></i>
      <span class="font-secondary-700">See More</span>
    </div>
    <!-- phones?.length < 5 -->
    <div [ngClass]="{'not-allowed':isMFCustomer}" class="p-0 mt-1 pointer width-fit-content"
      (click)="handleAddAnother('phone')" *ngIf="phones.length < 5 || showHidePhone">
      <i class="far fa-plus-circle font-primary pr-1"></i>
      <span class="font-secondary-700">Add phone</span>
      <span class="pl-4px">
        <i *ngIf="contactValidation?.phone?.icon" [class]="contactValidation?.phone?.icon" tooltipPosition="right"
          [pTooltip]="contactValidation?.phone?.tooltip"
          tooltipStyleClass="primary-contact-tooltip tooltip-z-index"></i></span>
    </div>

    <div class="row mx-0 p-0 mt-4 border-bottom-light pb-2">
      <div class="col rec-type p-0">
        <p class="m-0 font-bold font-secondary-700">Type</p>
      </div>

      <div class="col p-0 rec-phone">
        <p class="m-0 font-bold font-secondary-700 pl-6p">Email</p>
      </div>

      <div class="col rec-label" *ngIf="isMFCustomer">
        <img src="assets/myFleetCenterIntegration-icon.svg" />
        <span class="m-0 font-bold font-secondary-700 pl-6p">MFC Label</span>
      </div>

      <div class="col rec-label">
        <p class="m-0 font-bold font-secondary-700 pl-6p">Label</p>
      </div>

      <div class="col rec-primary">
        <p class="m-0 font-bold font-secondary-700 text-center">Primary</p>
      </div>

      <div class="col rec-active">
        <p class="m-0 font-bold font-secondary-700 text-center">Active</p>
      </div>

      <ng-container *ngIf="isMarketingOptOutEnabled && contactEntityType === 'customer'">
        <div *ngIf="isMarketingEnabled" class="col p-0 rec-marketing">
          <p class="m-0 font-bold font-secondary-700 pl-6p text-center">
            <span class="pr-2">Marketing</span>
            <i class="fal fa-info-circle text-dark" tooltipPosition="top" tooltipStyleClass="tooltip-z-index"
              pTooltip="Opt out/in of receiving promotional campaigns & follow-up reminders"></i>
          </p>
        </div>

        <div class="col-2 p-0 rec-reminders">
          <p class="m-0 font-bold font-secondary-700 pl-6p text-center">
            <span class="pr-2">Operational reminders</span>
            <i class="fal fa-info-circle text-dark" tooltipStyleClass="tooltip-z-index" tooltipPosition="top"
              pTooltip="Opt out/in of receiving appointment, payment review requests & send estimate reminders"></i>
          </p>
        </div>
      </ng-container>


      <div class="col p-0 rec-delete">
        <p class="m-0 font-bold font-secondary-700 pl-6p text-center">
          <!-- Delete -->
        </p>
      </div>
    </div>

    <div class="contact-body" #scrollEmail [scrollTop]="scrollEmail.scrollHeight">
      <!-- Email type -->
      <div class="row mx-0 contact-row position-relative" [ngClass]="{ 'disabled-row': !email?.isActive }"
        *ngFor="let email of emails | slice:0:emailLength; let emailIndex = index">
        <!-- Email type -->
        <div class="col p-0 flex-start-center rec-type height-34">
          <app-dropdown class="width-100p" id="email-type-{{ emailIndex }}" listId="email-list-type-{{ emailIndex }}"
            placeholder="Type" theme="light" field="label" [hasError]="errors.emails[emailIndex]?.contactType"
            [value]="{ label: 'Email' }" [errorMessage]="errors.emails[emailIndex]?.contactType" [fontSize]="14"
            [listItemFontSize]="13" [floatingLabel]="false" [options]="[]" [disabled]="true"
            [isDropdownIconVisible]="true" (appSelect)="handleMultiChange('emails', 'contactType', emailIndex, $event)">
          </app-dropdown>
        </div>

        <!-- Value -->
        <div class="col p-0 rec-phone height-34">
          <app-input id="email-{{ emailIndex }}" validationId="error-email-{{ emailIndex }}" theme="light"
            placeholder="Email" [errorMessage]="" [disabled]="!email?.isActive || isMFCustomer"
            [isInvalid]="errors.emails[emailIndex]?.value" [value]="email.value" [floatingLabel]="false"
            [maxLength]="253" (appChange)="handleMultiChange('emails', 'value', emailIndex, $event)"
            (appBlur)="handleBlur('email')">
          </app-input>
        </div>

        <div class="col rec-label flex-start-center" *ngIf="isMFCustomer">
          <div class="my-fleet-type-badge badge-blue" *ngIf="!email?.isPrimary; else authBadge">
            {{emailIndex === 1 ?'Contact':'Shipping'}}
          </div>
          <ng-template #authBadge>
            <div class="my-fleet-type-badge badge-green">
              Authorizer
            </div>
          </ng-template>
        </div>

        <!-- Label -->
        <div class="col rec-label height-34 input-elipsis">
          <app-input id="email-label-{{ emailIndex }}" validationId="error-email-label-{{ emailIndex }}" theme="light"
            placeholder="Label" [disabled]="!email?.isActive || isMFCustomer" [value]="email.label"
            [floatingLabel]="false" [errorMessage]="" [isInvalid]="errors.emails[emailIndex]?.label"
            (appChange)="handleMultiChange('emails', 'label', emailIndex, $event)"
            (appBlur)="handleBlur('label')"></app-input>
        </div>

        <!-- Primary -->
        <div class="col p-0 flex-center-center height-34 rec-primary">
          <div class="pt-8p d-flex justify-content-center flex-center">
            <app-radio-button id="email-primary-{{ emailIndex }}" name="email-primary" theme="light" label=""
              styleClassLabel="font-seconday" [disabled]="!email?.isActive || !email?.value"
              [selectedValue]="email?.isPrimary" [value]="true"
              (appChange)="handleMultiChange('emails', 'isPrimary', emailIndex, $event)">
            </app-radio-button>
          </div>
        </div>

        <!-- Active -->
        <div class="col p-0 flex-center-center height-34 rec-active">
          <div class="app-switch-right">
            <app-switch-pill id="email-active-{{ emailIndex }}" position="end" [fontSize]="14"
              [isActive]="email.isActive" [disabled]="email?.isPrimary || isMFCustomer" [label]=""
              (appChange)="handleMultiChange('emails', 'isActive', emailIndex, $event)">
            </app-switch-pill>
          </div>
        </div>

        <!-- Marketing -->
        <div *ngIf="isMarketingEnabled && isMarketingOptOutEnabled  && !isSupplier"
          class="col p-0 flex-center-center height-34 rec-marketing">
          <app-switch-pill id="email-marketing-{{ emailIndex }}" class="flex-center-center" position="end"
            [fontSize]="14"
            [isActive]="email.isMarketingNotifEnabled"
            [disabled]="!email.isActive"
            (appChange)="handleMultiChange('emails', 'isMarketingNotifEnabled', emailIndex, $event)">
          </app-switch-pill>
        </div>

        <!-- Operational -->
        <div *ngIf="isMarketingOptOutEnabled && !isSupplier"
          class="col-2 p-0 flex-center-center height-34 rec-reminders">
          <app-switch-pill id="email-operational-{{ emailIndex }}" class="flex-center-center" position="end"
            [fontSize]="14"
            [isActive]="email.isOperationalNotifEnabled"
            [disabled]="!email.isActive"
            (appChange)="handleMultiChange('emails', 'isOperationalNotifEnabled', emailIndex, $event)">
          </app-switch-pill>
        </div>

        <!-- Delete -->
        <div class="col p-0 rec-delete">
          <i class="fal fa-trash delete-btn font-gray-45 p-2" *ngIf="!email?.isPrimary && !isMFCustomer"
            pTooltip="Delete" tooltipStyleClass="tooltip-z-index" tooltipPosition="top"
            (click)="handleDeleteContact('emails', emailIndex)"></i>
        </div>
      </div>
    </div>

    <div class="p-0 mt-1 pointer" (click)="seeMore('email')"
      *ngIf="emailLength<=5 && !showHideEmail && isFleetCustomer">
      <i class="far fa-angle-down font-primary pr-1"></i>
      <span class="font-secondary-700">See More</span>
    </div>
    <div [ngClass]="{'not-allowed':isMFCustomer}" class="ui-g-12 p-0 mt-1 pointer width-fit-content"
      (click)="handleAddAnother('email')" *ngIf="emails.length < 5 || showHideEmail">
      <i class="far fa-plus-circle font-primary pr-1"></i>
      <span class="font-secondary-700">Add email</span>
      <span class="pl-10">
        <i *ngIf="contactValidation?.email?.icon" [class]="contactValidation?.email?.icon" tooltipPosition="right"
          [pTooltip]="contactValidation?.email?.tooltip"
          tooltipStyleClass="primary-contact-tooltip tooltip-z-index"></i></span>
    </div>
  </div>

  <div class="update-contact-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
    <button class="btn btn-primary btn-submit" [disabled]="isProcessing" (click)="handleSave()">
      Save
      <i class="fal fa-spinner rotate" *ngIf="isProcessing"></i>
    </button>
  </div>
</div>
